import React from 'react';
import { useJiraServiceManagementProjectNavigation as useJiraServiceManagementProjectNavigationBase } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/common/project-sidebar-navigation-resource/index.tsx';
import { SIDEBAR_ID } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/metrics/constants.tsx';
import {
	SidebarReady,
	SidebarRenderStart,
} from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/metrics/main.tsx';
import { useProject } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/project/index.tsx';
import { Skeleton } from '@atlassian/jira-navigation-apps-sidebar-common/src/ui/skeleton/index.tsx';
import { withThrowOnError } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/throw-when-no-data-and-error/index.tsx';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import useServiceProjectFeatures from '@atlassian/jira-servicedesk-features-store/src/index.tsx';
import { NavigationCategoryContainer } from '@atlassian/jira-servicedesk-queues-categorized-store/src/controllers/navigation-category/index.tsx';
import { usePracticeList } from '@atlassian/jira-servicedesk-queues-categorized-store/src/main.tsx';
import { MenuPractices } from './menu-practices/index.tsx';
import { Menu } from './menu/index.tsx';

const useJiraServiceManagementProjectNavigation = withThrowOnError(
	useJiraServiceManagementProjectNavigationBase,
);
const useThrowProject = withThrowOnError(useProject);

export const SidebarServicedesk = () => {
	const route = useCurrentRoute();
	const { loading: serviceProjectFeatureLoading } = useServiceProjectFeatures();

	const [practiceList, loadingPractice] = usePracticeList();
	const hasPractices = practiceList && practiceList.length > 1;
	const { data: project } = useThrowProject();

	const { data, loading } = useJiraServiceManagementProjectNavigation();
	if (
		loading ||
		loadingPractice ||
		data == null ||
		// route.group === 'servicedesk' means it's on project navigation, not under settings.
		// Data come back from useServiceProjectFeatures only controls items under "Operations" section on project navigation
		(serviceProjectFeatureLoading && route.group === 'servicedesk')
	) {
		return <Skeleton isFull />;
	}

	return (
		<>
			<SidebarRenderStart />
			<NavigationCategoryContainer
				projectKey={project ? project.key : ''}
				scope={project ? project.key : ''}
			>
				{hasPractices === true ? <MenuPractices /> : <Menu />}
			</NavigationCategoryContainer>
			{!__SERVER__ && <SidebarReady id={SIDEBAR_ID.JSM} />}
		</>
	);
};

export default SidebarServicedesk;
